import * as v from "valibot";

// request schema
export const RequestSchema = v.object({
  EnableAutoScale: v.boolean(),
  MaxSize: v.nullish(v.number()),
  MinSize: v.nullish(v.number()),
  NodePoolId: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema
export const DataSchema = v.object({
  NodePoolId: v.string(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
